// src/pages/UserGuide.js
import React from 'react';
import Navbar from './Navbar';

const UserGuideDetails = () => {
  const hostUrl = window.location.origin;  
  return (
    <div style={{ height: '100vh' }}>
      <Navbar />
      <h2 style={{ textAlign: 'center' }}>User Guide</h2>
      <iframe
        src="pdfs/DIVAUserGuide.pdf"
        width="100%"
        height="90%"
        style={{ border: 'none' }}
        title="User Guide PDF"
      ></iframe>
    </div>
  );
};

export default UserGuideDetails;
